import { render, staticRenderFns } from "./SVGShadeOff.vue?vue&type=template&id=bee3fd8e&scoped=true&"
import script from "./SVGShadeOff.vue?vue&type=script&lang=js&"
export * from "./SVGShadeOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee3fd8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee3fd8e')) {
      api.createRecord('bee3fd8e', component.options)
    } else {
      api.reload('bee3fd8e', component.options)
    }
    module.hot.accept("./SVGShadeOff.vue?vue&type=template&id=bee3fd8e&scoped=true&", function () {
      api.rerender('bee3fd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGShadeOff.vue"
export default component.exports